module.exports = __webpack_public_path__ + "static/media/profilenosuit.186b8c4a.png";